import React from 'react'

import { alertaSucesso } from '../../../../utils/alternanciaIcones'
import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

export default function Cancelamento({ close, opened }) {
  return (
    <div>
      <Modal width="750px" type="alerta" opened={opened} disableElipse>
        <S.ModalAlert>
          <S.IconeWrapper>
            <S.Img src={alertaSucesso()} alt="sucesso" />
            <p>Sucesso</p>
          </S.IconeWrapper>
          <S.Mensagem>
            <p>
              Recebemos sua solicitação e ela será finalizada em até 5 dias
              úteis. As cobranças permanecem ativas até a conclusão do
              atendimento.
            </p>
            <p>
              Um Analista de Sucesso do Cliente entrará em contato em breve.
              Você pode acompanhar o status diretamente pela plataforma.
            </p>
          </S.Mensagem>
          <Group position="center">
            <Botao label="Fechar" onClick={close} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
